import { motion } from "framer-motion";
import { IMAGES } from "./data";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Luxury event" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-background/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-background/40" />
        <div className="absolute inset-0 bg-grain opacity-[0.04]" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 w-full pt-24">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overline mb-6"
        >
          9jaclicks Limited — Premium Settlement & Lifestyle
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-light text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-tighter max-w-4xl"
        >
          Cross borders.
          <br />
          Arrive <span className="italic text-gold">home</span>.
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.6 }}
          className="mt-8 max-w-xl text-lg font-light leading-relaxed text-foreground/70"
        >
          Premium settlement services for families relocating across borders — immigration, luxury housing, schooling and
          every detail, handled end to end. Plus investment, travel and lifestyle, curated with discretion.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8 }}
          className="mt-12 flex flex-wrap items-center gap-5"
        >
          <a
            href="#contact"
            data-testid="hero-cta-button"
            className="bg-gold text-primary-foreground px-9 py-4 text-xs uppercase tracking-[0.2em] hover:bg-gold/90 transition-all duration-500"
          >
            Book a Consultation
          </a>
          <a
            href="#services"
            data-testid="hero-services-link"
            className="group inline-flex items-center gap-3 text-sm tracking-wide text-foreground/80 hover:text-gold transition-colors duration-300"
          >
            Explore our world
            <span className="h-px w-8 bg-gold transition-all duration-500 group-hover:w-12" />
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-foreground/40">Scroll</span>
        <span className="h-10 w-px bg-gradient-to-b from-gold to-transparent" />
      </div>
    </section>
  );
}
